import { RouteRecordRaw } from 'vue-router'

const workOrder: Array<RouteRecordRaw> = [
    {
        path: '/workOrder',
        name: 'workOrder',
        redirect: '/workOrder/index',
        component: () => import('@/views/children.vue'),
        children: [
            {
                path: '/workOrder/index',
                name: 'workOrderIndex',
                meta: {
                    title: '生产工单',
                    keepAlive: true
                },
                component: () => import('@/views/workOrder/index.vue')
            },
            {
                path: '/workOrder/details-front',
                name: 'workOrderDetails-front',
                meta: {
                    title: '工单详情',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/details-front.vue')
            },
            {
                path: '/workOrder/manualFeeding',
                name: 'manualFeeding',
                meta: {
                    title: '手动投料',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/manualFeeding.vue')
            },
            {
                path: '/workOrder/codeScanningFeeding',
                name: 'codeScanningFeeding',
                meta: {
                    title: '扫码投料',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/codeScanningFeeding.vue')
            },
            {
                path: '/workOrder/manualOutput',
                name: 'manualOutput',
                meta: {
                    title: '手动产出',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/manualOutput.vue')
            },
            {
                path: '/workOrder/spotCheck',
                name: 'spotCheck',
                meta: {
                    title: '生产点检',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/spotCheck.vue')
            },
            {
                path: '/workOrder/codeScanningOutput',
                name: 'codeScanningOutput',
                meta: {
                    title: '扫码产出',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/codeScanningOutput.vue')
            },
            {
                path: '/workOrder/workOrderReporting',
                name: 'workOrderReporting',
                meta: {
                    title: '工单报工',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/workOrderReporting.vue')
            },
            {
                path: '/workOrder/afterWorkReport',
                name: 'afterWorkReport',
                meta: {
                    title: '工单详情',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/afterWorkReport.vue')
            },
            {
                path: '/workOrder/basketChange',
                name: 'basketChange',
                meta: {
                    title: '换篮筐',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/basketChange.vue')
            },
            {
                path: '/workOrder/bindingDevice',
                name: 'bindingDevice',
                meta: {
                    title: '绑设备',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/bindingDevice.vue')
            },
            {
                path: '/workOrder/wipCompletion',
                name: 'wipCompletion',
                meta: {
                    title: '完工入库',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/wipCompletion.vue')
            },
            {
                path: '/workOrder/secondShift',
                name: 'secondShift',
                meta: {
                    title: '选择余留次班',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/secondShift.vue')
            },
            {
                path: '/workOrder/warehousingTwo',
                name: 'warehousingTwo',
                meta: {
                    title: '完工入库第二步',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/warehousingTwo.vue')
            },
            {
                path: '/workOrder/orderStock',
                name: 'orderStock',
                meta: {
                    title: '备料确认',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/orderStock.vue')
            },
            {
                path: '/workOrder/newWipCompletion',
                name: 'newWipCompletion',
                meta: {
                    title: '完工入库',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/newWipCompletion.vue')
            },
            {
                path: '/workOrder/completionDetails',
                name: 'completionDetails',
                meta: {
                    title: '完工入库详情',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/completionDetails.vue')
            },
            {
                path: '/workOrder/checkTheProcess',
                name: 'checkTheProcess',
                meta: {
                    title: '查工艺',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/checkTheProcess.vue')
            },
            {
                path: '/workOrder/InspectTooling',
                name: 'InspectTooling',
                meta: {
                    title: '查工装',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/InspectTooling.vue')
            },
            {
                path: '/workOrder/location',
                name: 'location',
                meta: {
                    title: '查货位',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/location.vue')
            },
            {
                path: '/workOrder/reportingForWork',
                name: 'reportingForWork',
                meta: {
                    title: '一键报工',
                    keepAlive: true
                },
                component: () => import('@/views/workOrder/reportingForWork.vue')
            },
            {
                path: '/workOrder/processPlans',
                name: 'processPlans',
                meta: {
                    title: '选择工序计划',
                    keepAlive: false
                },
                component: () => import('@/views/workOrder/processPlan.vue')
            }
        ]
    }
]

export default workOrder
